import Styled from "styled-components";
import { respondTo } from "@/respondTo";
// Mobile Menu
export const MenuMobileContainer = Styled.div<{ isOpen: boolean; theme: string }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => (theme === "dark" ? "var(--on-primary-dark)" : "var(--background-light)")};
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? "translateY(0)" : "translateY(-100%)")};
    opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
`;

export const InnerContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 1.25rem 1.25rem 2.5rem;
    gap: 2.5rem;
    
    `;

export const CloseIcon = Styled.div<{ theme: string }>`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    cursor: pointer;
    svg {
        color: ${({ theme }) => (theme === "dark" ? "var(--background-light)" : "var(--on-surface-light)")};
    }
`;

export const SelectorsContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    align-items: flex-start;
    gap: 2.5rem;
 
`;

export const ButtonsContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    align-items: center;
    gap:1.25rem;
`;

//Large Menu

export const MenuLargeContainer = Styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:1.25rem;
    `;

export const SelectorContainer = Styled.div<{ theme: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.25rem;

    h1{
        color: ${({ theme }) => (theme === "dark" ? "var(--background-light)" : "var(--on-primary-dark)")};
    }
    `;

export const LanguageContainer = Styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    `;

export const ButtonContainer = Styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.25rem;
    `;

export const TabSelector = Styled.h6<{ theme: string }>`
    color:  ${({ theme }) => (theme === "dark" ? "var(--background-light)" : "var(--on-primary-dark)")};
    `;

export const LanguageSelector = Styled.h6<{ isActive?: boolean; theme: string }>`
    font-weight: ${({ isActive }) => (isActive ? "600" : "400")};
    color:  
    cursor: pointer;
    color: ${({ theme }) => (theme === "dark" ? "var(--background-light)" : "var(--on-surface-light)")};
    ${respondTo.tablet_landscape_s`
    cursor: pointer;
    
    `}
    `;
